import React from 'react';
import styled from 'styled-components';

export const RowContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
